import React, { FC } from "react";
import { useMediaQuery } from "react-responsive";
import { useQueryParams } from "src/hooks/useQueryParams";
import { Header } from "src/page-components/blog/Header";
import { MainSection } from "src/page-components/blog/MainSection";
import { QueryParamKeys } from "src/page-components/blog/types";
import { PageWrapper } from "src/components/Layouts/PageWrapper";
import { BreadCrumbs } from "src/components/BreadCrumbs";
import { breadCrumbsTrns } from "src/components/BreadCrumbs/trns";
import { IBreadCrumbsItem } from "src/components/BreadCrumbs/types";
import { PATHNAMES } from "src/constants/routes";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";
import { MetadataWrapper } from "src/components/MetadataWrapper";
import { selectorCategories } from "src/redux/blog/selector";
import { useAppSelector } from "src/hooks/redux";

const Blog: FC = () => {
  const isGLScreenBreakpoint = useMediaQuery({
    maxWidth: SCREEN_BREAKPOINTS.GL,
  });

  const { getQueryParam } = useQueryParams();
  const category = getQueryParam(QueryParamKeys.CATEGORY);

  const isCategorySelected = category !== null;

  const breadCrumbsItems: IBreadCrumbsItem[] = isCategorySelected
    ? [
        { title: { i18nKey: breadCrumbsTrns.home }, path: PATHNAMES.HOME },
        { title: { i18nKey: breadCrumbsTrns.blog }, path: PATHNAMES.BLOG },
        { title: category },
      ]
    : [
        { title: { i18nKey: breadCrumbsTrns.home }, path: PATHNAMES.HOME },
        { title: { i18nKey: breadCrumbsTrns.blog } },
      ];

  const categories = useAppSelector(selectorCategories) || [];
  const activeCategory =
    categories.find(({ slug }) => slug === category) || categories[0];

  return (
    <MetadataWrapper
      title={activeCategory?.category_meta_title}
      description={activeCategory?.category_meta_description}
    >
      <PageWrapper mainClassName="py-5 sm:py-10 mt-19">
        <section className="container flex flex-col gap-5 gl:gap-10 default:overflow-visible">
          {!isGLScreenBreakpoint && <BreadCrumbs items={breadCrumbsItems} />}
          <Header />
          <MainSection />
        </section>
      </PageWrapper>
    </MetadataWrapper>
  );
};

export default Blog;
